/**
 * Skeleton determinístico para section deferida que não exporta
 * `LoadingFallback`.
 *
 * O `DeferredSectionWrapper` (`@decocms/tanstack`, DecoPageRenderer) decide o
 * skeleton no primeiro render por `!!getSectionOptions(key)`: com options,
 * desenha o `LoadingFallback` da section ou, sem ele, o `DefaultSectionFallback`
 * (um bloco cinza de 192px); sem options, não desenha nada.
 *
 * No cliente, na hidratação, só tem options quem as convenções registram —
 * `sync`, `clientOnly`, `LoadingFallback`, `renderJson`. No servidor, também
 * todo módulo que o isolate já carregou: `preloadSectionComponents` grava `{}`
 * para cada section eager de cada request (a mesma section é eager para o
 * Googlebot e deferida para gente). A partir daí o SSR daquele isolate emite os
 * 192px que a hidratação não emite, e o React aborta com o erro #418.
 *
 * Medido em 21/10/2026 na `/sex-shop` desktop com MISS forçado: 4 de 10 cargas
 * vieram com o skeleton na `v2/search/SearchDescription`. O HTML ruim deu #418
 * em 4/4 no replay, e o mesmo HTML sem aquele `<div>` deu 0/4.
 *
 * Um `LoadingFallback` vazio, registrado igual nos dois lados, fixa a decisão
 * e mantém o que a página já mostrava na carga boa (a section vazia até
 * carregar). O `preloadSectionComponents` preserva o fallback: ele mescla as
 * options e só troca `loadingFallback` quando o módulo exporta um.
 */
import { getSectionOptions, registerSection } from "@decocms/blocks/cms";

export function EmptyLoadingFallback() {
  return null;
}

/**
 * Roda DEPOIS de `applySectionConventions`, para só pegar as sections que as
 * convenções deixaram sem options.
 */
export function registerEmptyDeferredFallbacks(sections: Record<string, () => Promise<any>>): void {
  for (const [key, loader] of Object.entries(sections)) {
    if (getSectionOptions(key)) continue;
    registerSection(key, loader, { loadingFallback: EmptyLoadingFallback });
  }
}
